export default "__VITE_ASSET__BeNWcoHl__"